// Purpose: Gives every BayHive Dialog footer Lara's modal padding on every
// edge, so its action row is vertically balanced without page-level CSS.
export const dialogComponents = {
  dialog: {
    footer: {
      padding: '{overlay.modal.padding}',
    },
  },
};

export default dialogComponents;
